// extracted by mini-css-extract-plugin
module.exports = {"banner__details":"styles_banner__details__BQDwV","pulse":"styles_pulse__R2KJH","jump":"styles_jump__VWwdp"};